import React from "react";
import { Link } from "react-router-dom";
import { HOMEPAGE_BLOCK_IMAGES } from "@/data/serviceImages";

const REMODELING_ITEMS = [
  "Kitchen remodels",
  "Bathroom remodels",
  "Full home remodels",
  "Home additions",
  "ADUs & garage conversions",
  "Investor make-readies",
];

export default function HomeRemodelingBlock() {
  return (
    <section className="section-pad bg-br-paper">
      <div className="container-br grid lg:grid-cols-2 gap-10 items-center">
        <div className="order-2 lg:order-1 relative">
          <img src={HOMEPAGE_BLOCK_IMAGES.remodeling} alt="Premium kitchen remodel — white cabinetry, marble island, brass hardware" className="rounded-md w-full object-cover aspect-[16/9]" />
        </div>
        <div className="order-1 lg:order-2">
          <div className="br-eyebrow">Remodeling & GC Work</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Kitchens, Baths, Full Remodels & Additions</h2>
          <p className="mt-3 text-gray-700">As a real general contractor, we manage every trade involved — plumbing, electrical, drywall, paint, tile, cabinets, flooring, finish carpentry, exterior tie-ins, and roofing touch-ups. One scope, one schedule, one point of contact.</p>
          <ul className="mt-4 grid sm:grid-cols-2 gap-2 text-sm text-gray-700">
            {REMODELING_ITEMS.map((t) => (
              <li key={t} className="flex gap-2"><span className="text-br-bronze">▪</span> {t}</li>
            ))}
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/remodeling" className="br-btn-dark">View Remodeling</Link>
            <Link to="/construction-services" className="br-btn-secondary" style={{color:"#0a0a0a", borderColor:"#0a0a0a"}}>All Construction Services</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
